module.exports = __webpack_public_path__ + "media/palutena.e92aa1a0.wav";